// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@steiner/App/Components/Notify";
import { productCountStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListProductCount";
import { mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productCountStyles.wrapper = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin-bottom: 0;
            flex-wrap: wrap;
            ${xScreen("lte","md")} {
                max-width: 100%;
            }
        `,
    }),
};
productCountStyles.productsOnlycountText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
        white-space: nowrap;
    `,
};

productCountStyles.itemsText = {};

productCountStyles.queryText = {
    css: css`
            white-space: wrap;
            font-weight: bold;
        `,
};
